import React from "react";
import DashboardContainer from "../../containers/Dashboard";

function Dashboard(props) {
  return <DashboardContainer {...props} />;
}

export default Dashboard;
